import React, { useState } from 'react';
import useSearchDebounce from '../../../../hooks/useSearchDebounce';
import CaregiverSearchControl from '../../../../components/modals/CaregiverShiftActionModals/CaregiverSearchControl';
import LoadingSpinner from '../../../../components/spinner/LoadingSpinner';
import ShiftDetails from './shift-details/ShiftDetails';
import { SEARCH_MIN_CHARS } from '../../../../constants';

import './AgencyAssign.scss';

const AgencyAssign = ({ shift, bundle, removeCaregiver, addCaregiver, selectedCaregivers, showLoadingSpinner }) => {
	const [loading, setLoading] = useState(false);
	const [errorSearch, setErrorSearch] = useState(false);
	const [showSelectedProfessionals, setShowSelectedProfessionals] = useState(false);
	const [searchValue, setSearchValue] = useState('');
	const [searchedCaregivers, setSearchCaregivers] = useState([]);

	const handleResults = (results = []) => {
		const caregiversHaystack = new Set(selectedCaregivers.map((c) => c.caregiver_id));
		const filterResults = results.filter((c) => !caregiversHaystack.has(c.caregiver_id));
		setSearchCaregivers(filterResults);
	};

	let searchURL;
	if (shift) {
		const shiftId = shift.is_recurring ? shift.recurring_shift_id : shift.shift_id;
		searchURL = `/agencies/shift/${shiftId}/search-professionals`;
	}

	if (bundle) {
		const bundleId = bundle.contract_id;
		searchURL = `/agencies/bundle/${bundleId}/search-professionals`;
	}

	const { searchTermChange } = useSearchDebounce(
		searchURL,
		searchValue,
		{},
		setSearchValue,
		setLoading,
		setErrorSearch,
		handleResults,
		SEARCH_MIN_CHARS
	);

	const addSelectedCaregiver = (caregiver, clearSelectedCaregivers) => {
		setSearchValue('');
		setSearchCaregivers([]);
		setShowSelectedProfessionals(true);
		addCaregiver(caregiver, clearSelectedCaregivers);
	};

	const removeSelectedProfessional = (evt, caregiver) => {
		if (evt) evt.preventDefault();
		setShowSelectedProfessionals(false);
		removeCaregiver(caregiver);
	};

	return (
		<div className="assign-professional-container">
			<ShiftDetails shift={shift} bundle={bundle} />
			<br />
			<CaregiverSearchControl
				shouldHandleAgencyJoined
				addSelectedCaregiver={addSelectedCaregiver}
				errorSearch={errorSearch}
				searchValue={searchValue}
				searchTermChange={searchTermChange}
				selectedCaregivers={selectedCaregivers}
				removeSelectedProfessional={removeSelectedProfessional}
				loading={loading}
				searchedCaregivers={searchedCaregivers}
				showSelectedProfessionals={showSelectedProfessionals}
				copy={false}
				inputPlaceholder="Search professional with matching shift type"
				searchSectionTitle="Search and Select Professional"
				selectedSectionTitle="Selected Professional"
				allowSingleCaregiverSelection
			/>
			{showLoadingSpinner && <LoadingSpinner />}
		</div>
	);
};

export default AgencyAssign;
